import React, { useState } from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import AddIcon from '@material-ui/icons/Add';
import {
    withStyles,
    Paper,
    Toolbar,
    Tooltip,
    Typography,
    Button,
    IconButton,
} from '@material-ui/core';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { Link, useHistory } from 'react-router-dom';
import styles from './styles';
import ConfirmDialog from '../../ConfirmDialog';

function CriancasTable({ classes, criancas, idMembro, handleRemoverItem }) {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [membroSelecionado, setMembroSelecionado] = useState(false);
    const [mostrarModalAdicionar, setMostrarModalAdicionar] = useState(false);
    const history = useHistory();

    return (
        <Paper>
            <Toolbar className={classes.toolbar}>
                <Tooltip title="Adicionar">
                    <Button
                        onClick={() => setMostrarModalAdicionar(true)}
                        variant="outlined"
                        className={classes.buttonCriar}
                    >
                        <AddIcon color="primary" />
                        <Typography
                            color="primary"
                            variant="body1"
                            component="span"
                        >
                            Adicionar Criança
                        </Typography>
                    </Button>
                </Tooltip>
            </Toolbar>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Nome</TableCell>
                        <TableCell>
                            <span>Data de Nascimento</span>
                        </TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {criancas.map(row => (
                        <TableRow hover key={row.id}>
                            <TableCell
                                className={classes.tableCellNome}
                                scope="row"
                                align="left"
                                component={Link}
                                to={{
                                    pathname: `/crianca/${idMembro}/${row.id}`,
                                }}
                            >
                                {row.txNome}
                            </TableCell>
                            <TableCell align="left">
                                {row.dtNascimento}
                            </TableCell>
                            <TableCell align="center">
                                <IconButton
                                    onClick={() => {
                                        setConfirmOpen(true);
                                        setMembroSelecionado(row);
                                    }}
                                >
                                    <RemoveCircleOutlineIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <ConfirmDialog
                title="Remover do Grupo"
                open={confirmOpen}
                setOpen={setConfirmOpen}
                onConfirm={e => handleRemoverItem(e, membroSelecionado)}
            >
                {`Tem certeza que deseja remover ${membroSelecionado.txNome} do seu grupo?`}
            </ConfirmDialog>

            <ConfirmDialog
                title="Cadastrar Infantil/Kids"
                open={mostrarModalAdicionar}
                setOpen={setMostrarModalAdicionar}
                onConfirm={() => history.push(`/cadastrar_crianca/${idMembro}`)}
            >
                {`Opção disponível apenas para cadastro de crianças do Nova Infantil e Nova Kids. Deseja prosseguir?`}
            </ConfirmDialog>
        </Paper>
    );
}

export default withStyles(styles)(CriancasTable);
